import {
  getToken,
  removeToken,
  removeCookie,
  setToken,
  setCookie
} from '@/utils/auth'
import { login } from '@/api/admin'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    userinfo: '',
    roles: [],
    reLogin: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USERINFO: (state, userinfo) => {
      state.userinfo = userinfo
    },
    SET_RELOGIN: (state, login) => {
      state.reLogin = login
    }
  },

  actions: {
    // 登录
    Login({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then(res => {
            commit('SET_TOKEN', res.result.token)
            commit('SET_NAME', res.result.login_name)
            setToken(res.result.token)
            setCookie('login_name', res.result.login_name)
            setCookie('role_id', res.result.role_id)
            resolve(res)
          })
          .catch(() => {
            reject()
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise(resolve => {
        if (process.env.VUE_APP_LOGIN) {
          console.log('需要登陆')
        } else {
          commit('SET_USERINFO', '111')
          commit('SET_NAME', 'admin')
          commit(
            'SET_AVATAR',
            'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
          )
          resolve({
            code: 0,
            data: {
              sourcright: '111',
              sparoutes: '222'
            },
            msg: ''
          })
        }
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeCookie('login_name')
        resolve()
      })
    }
  }
}

export default user
